<template>
  <div class="box">
    <div class="side-header">
      測試者
      <ion-icon v-if="show_add" src="/assets/icon/add-circle-outline.svg" class="add-icon"
        @click="showAddPage"></ion-icon>
    </div>
    <div class="side-box enable-scroll">
      <input v-if="is_staff" class="input" type="text" placeholder="搜尋參考編號或名稱" @input="searchUser" v-model="search_item">
      <div class="side-title user-side enable-scroll-child" v-for="user in data" v-bind:key="user.id" :data-id="user.id"
        @click="clickTitle(user.id)">
        {{ this.truncateName(user.name) }}
        <ion-icon v-if="user.id == current_id" src="/assets/icon/trash-outline.svg" class="trash-icon"
          @click="deleteUser(user.id, user.name)"></ion-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { IonIcon } from "@ionic/vue";
import common from "@/common";

export default {
  name: "HomeUserList",
  components: {
    IonIcon
  },
  data() {
    return {
      current_id: 0,
      is_staff: false,
      search_item: '',
      origin_data: [],
    }
  },
  props: {
    data: { type: Array },
    show_add: { type: Boolean, default: false },
  },
  mounted() {
    this.showFirstTitle();
    common.getStorage('staff').then(staff => {
      if (staff) {
        this.is_staff = true;
      }
    })
  },
  methods: {
    truncateName: function (name) {
      let len = 0;
      for (let i = 0; i < name.length; i++) {
        const charCode = name.charCodeAt(i);
        // 判断是否为中文字符
        if ((charCode >= 0x0080 && charCode <= 0x07FF) || (charCode >= 0x0800 && charCode <= 0xFFFF)) {
          len += 2;
        } else {
          len += 1;
        }
        if (len > 6) {
          return name.slice(0, i) + "...";
        }
      }
      return name;
    },
    clickTitle: function (id) {
      this.current_id = id;
      const objs = document.getElementsByClassName('user-side');
      for (let i = 0; i < objs.length; i++) {
        objs[i].classList.remove('side_selected')
        if (objs[i].dataset.id == id) {
          objs[i].classList.add('side_selected');
          this.$emit('selectUser', id);
        }
      }
    },
    showFirstTitle: function () {
      this.$nextTick(() => {
        const ele = document.createEvent("MouseEvents");
        ele.initEvent("click", true, true);
        const objs = document.getElementsByClassName('user-side')
        if (objs.length === 0) return;
        objs[0].dispatchEvent(ele);
      })
    },
    showAddPage: function () {
      this.current_id = 0;
      const objs = document.getElementsByClassName('user-side');
      for (let i = 0; i < objs.length; i++) {
        objs[i].classList.remove('side_selected')
      }

      this.$emit('showAddPage')
    },
    deleteUser: function (id, name) {
      common.showConfirm('是否確認移除測試者 ' + name, '確認刪除', function (param) {
        param.ele.$emit('deleteUser', param.id);
      }, { id: id, ele: this })
    },
    searchUser: function () {
      this.$emit('searchUser', this.search_item)
    },
    clearUserName: function () {
      this.search_item = '';
      this.$emit('showAllUsers')
    }
  }
}
</script>

<style scoped>
.box {
  height: 100%;
}

.add-icon {
  position: absolute;
  /*margin-left: 50%;*/
  color: #94c43c;
  top: 1.6vw;
  right: 1vw;
}

.trash-icon {
  float: right;
  margin-top: 0.6vw;
  margin-right: 5%;
}

.input {
  width: 90%;
  margin: 1vh 5%;
  box-sizing: border-box;
  min-height: var(--ecs-form-control-min-height);
  padding: var(--ecs-form-control-padding-y) var(--ecs-form-control-padding-x);
  opacity: 0.5;
}
</style>
